<div *ngIf="test" class="col-12 p-5 custom-form">
  <div class="card p-5">
    <div *ngIf="formStarted" >
      <p *ngIf="testTimer" class="text-right">Tiempo restante: <span class="text-success">{{secondsToStringTime(testTimerQty)}}</span></p>
      <section class="questions-items-container mb-4">
        <div *ngFor="let item of test.questions; index as i" class="question-item" [ngStyle]="{'width':(100/test.questions.length)+'%'}" [ngClass]="i <= selectedQuestionIndex ? 'question-completed' : ''" ></div>
      </section>
    </div>

    <h2 *ngIf="!formStarted" class="modal-title text-center" id="myModalLabel"><b>{{test.title}}</b></h2>
    <div *ngIf="!formStarted" class="row">
      <div *ngIf="welcome" class="col-12 p-3 text-break">
        <!-- <quill-view *ngIf="test.description" [content]="test.description.ops"></quill-view> -->
        <!-- <div [innerHTML]="test.description | quillToHtml"></div> -->
        <div class="description-editor"></div>
        <div class="col-12 px-5">
          <button class="btn btn-warning waves-effect btn-rounded mt-3 mx-2" (click)="reload()">Cancelar</button>
          <button class="btn btn-info waves-effect btn-rounded pull-right mt-3" (click)="formWelcome = false; formStarted = true; startForm()">Comenzar</button>
        </div>
      </div>
    </div>


    <div *ngIf="formStarted && selectedQuestion" class="row justify-content center">
        <div class="col-12">
            <div *ngIf="showInstructions" class="instructions-editor"></div>
            <!-- <div *ngIf="showInstructions" [innerHTML]="selectedQuestion.instructions | quillToHtml" ></div> -->

            <span  class="instructions-timer mb-5" *ngIf="instructionTimer && instructionTimerQty > 0">Las instrucciones se ocultarán en: {{secondsToStringTime(instructionTimerQty)}}</span>
            <span  class="instructions-timer mb-5" *ngIf="questionTimer && questionTimerQty > 0">Las pregunta se ocultará en: {{secondsToStringTime(questionTimerQty)}}</span>
            <hr class="my-3">
            <!-- <div [innerHTML]="selectedQuestion.question | quillToHtml" ></div> -->
            <div *ngIf="showQuestion" class="question-editor"></div>
            <div *ngIf="selectedQuestion.questionImage && showQuestion" class="questionImg text-center">
              <img [src]="selectedQuestion.questionImage" alt="">
            </div>
            
            <ng-container *ngIf="!isTimedQuestion || (isTimedQuestion && !showInstructions) || (isTimedQuestion && !showQuestion)">
              <div *ngIf="selectedQuestion.type=='text' || selectedQuestion.type=='number'" class="form-group mt-4">
                  <input autocomplete="off" [(ngModel)]="fieldValue" [type]="selectedQuestion.type"  class="form-control" [placeholder]="" >
              </div>
              <div *ngIf="selectedQuestion.type == 'checkbox' || selectedQuestion.type == 'multiple'" class="demo-radio-button mt-4">
                  <div class="row px-3">
                      <div [ngClass]="isSelected(selectedQuestionIndex, opt.title) ? 'option-selected' : ''" class='option col-12'*ngFor="let opt of selectedQuestion.answers; index as j" (click)="toggleSelectedOption(selectedQuestionIndex , opt.title, selectedQuestion.type == 'multiple' ? true : false, opt._id)" >
                        <!-- <img [src]="isSelected(selectedQuestionIndex, opt.title) ? '/assets/images/icon/check.png' : '/assets/images/icon/uncheck.png'" alt=""> -->
                        <b>{{opt.title}}</b>
                      </div>
                  </div>
              </div>

              <div *ngIf="selectedQuestion.type == 'conditional'" class="demo-radio-button mt-4">
                <div class="row px-3">
                  <ng-container *ngFor="let opt of selectedQuestion.answers; index as j">
                    <div [ngClass]="isSelected(selectedQuestionIndex, opt.title) ? 'option-selected' : ''" class='option col-12' >
                      <div (click)="toggleSelectedOption(selectedQuestionIndex , opt.title, false, opt._id)">
                        <!-- <img [src]="isSelected(selectedQuestionIndex, opt.title) ? '/assets/images/icon/check.png' : '/assets/images/icon/uncheck.png'" alt=""> -->
                        <b>{{opt.title}}</b>

                      </div>
                    </div>
                    <div *ngIf="isSelected(selectedQuestionIndex, opt.title) && opt.requestInput" class="form-group w-100 mt-3">
                      <p><small>{{selectedQuestion.customPlaceholder}}</small></p>
                      <input autocomplete="off" [(ngModel)]="conditionalField" [type]="'text'"  class="form-control" [placeholder]="'Respuesta'">
                    </div>
                  </ng-container>
                </div>
            </div>
            </ng-container>

          </div>
          <div class="col-12 px-5">
            <button *ngIf="(canGoBack && selectedQuestionIndex > 0)" class="btn btn-info waves-effect btn-rounded mt-3" (click)="back()">Anterior</button>
            <button class="btn btn-info waves-effect btn-rounded pull-right mt-3" (click)="next()">Continuar</button>
          </div>
    </div>

  </div>

</div>
<app-camera *ngIf="testData && testData.camera" [testData]="testData" [trigger]="trigger"></app-camera>

<!-- <div *ngIf="testTimer" class="test-timer">
  <div class="timer">
    <span>Tiempo restante</span>
    <span>{{secondsToStringTime(testTimerQty)}}</span>
  </div>
</div> -->